import { css } from "lit";

export const coreCSS = css`
	@supports (--foo: "mds") {
		:host *::before,
		:host *::after,
		:host *,
		:host {
			box-sizing: border-box;
		}
		:host {
			-webkit-font-smoothing: antialiased;
			overflow: visible;
			font-family: var(--mds-typography-font-base-fonts);
			font-size: calc(
				var(--mds-typography-scale-increment-body) *
					var(--mds-typography-font-size) * 1rem
			);
			line-height: var(--mds-typography-font-height);
			font-weight: var(--mds-typography-font-base-weight-normal);
			color: var(--mds-color-text-default);
			-moz-text-size-adjust: none;
			-webkit-text-size-adjust: none;
			text-size-adjust: none;
		}

		.mds-body-large {
			font-size: larger; /* IE11 fallback */
			--mds-typography-font-size: calc(
				var(--mds-typography-scale-size-body) + 1
			);
		}

		.mds-body-small {
			font-size: smaller; /* IE11 fallback */
			--mds-typography-font-size: calc(
				var(--mds-typography-scale-size-body) - 1
			);
		}

		.mds-body-large,
		.mds-body-small {
			font-size: calc(
				var(--mds-typography-scale-increment-body) *
					var(--mds-typography-font-size) * 1rem
			);
		}

		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			margin-inline: 0;
			margin-block: var(--mds-spacing-6) var(--mds-spacing-3);
			font-family: var(--mds-typography-font-display-fonts);
			font-size: calc(
				var(--mds-typography-scale-increment-headings) *
					var(--mds-typography-font-size) * 1rem
			);
			line-height: var(--mds-typography-font-height);
			font-weight: var(--mds-typography-font-display-weight-normal);
			color: var(--mds-color-text-heading);
		}

		h1:first-child,
		h2:first-child,
		h3:first-child,
		h4:first-child,
		h5:first-child,
		h6:first-child {
			margin-top: 0;
		}

		h1:last-child,
		h2:last-child,
		h3:last-child,
		h4:last-child,
		h5:last-child,
		h6:last-child {
			margin-bottom: 0;
		}

		/* Mobile */
		@media not all and (min-width: 768px) {
			h1 {
				--mds-typography-font-size: var(
					--mds-typography-scale-size-xxl
				);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-m
				);
			}

			h2 {
				--mds-typography-font-size: var(--mds-typography-scale-size-xl);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-l
				);
			}

			h3 {
				--mds-typography-font-size: var(--mds-typography-scale-size-l);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-xl
				);
			}

			h4 {
				--mds-typography-font-size: var(--mds-typography-scale-size-m);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-s
				);
			}

			h5 {
				--mds-typography-font-size: var(--mds-typography-scale-size-s);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-m
				);
			}

			h6 {
				--mds-typography-font-size: var(--mds-typography-scale-size-s);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-m
				);
			}
		}

		/* Tablet */
		@media (min-width: 768px) {
			h1 {
				--mds-typography-font-size: var(
					--mds-typography-scale-size-xxl
				);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-m
				);
			}

			h2 {
				--mds-typography-font-size: var(--mds-typography-scale-size-xl);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-l
				);
			}

			h3 {
				--mds-typography-font-size: var(--mds-typography-scale-size-l);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-xl
				);
			}

			h4 {
				--mds-typography-font-size: var(--mds-typography-scale-size-m);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-s
				);
			}

			h5 {
				--mds-typography-font-size: var(--mds-typography-scale-size-s);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-m
				);
			}

			h6 {
				--mds-typography-font-size: var(--mds-typography-scale-size-s);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-m
				);
			}
		}

		/* Desktop */
		@media (min-width: 1200px) {
			h1 {
				--mds-typography-font-size: var(
					--mds-typography-scale-size-xxxl
				);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-s
				);
			}

			h2 {
				--mds-typography-font-size: var(
					--mds-typography-scale-size-xxl
				);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-m
				);
			}

			h3,
			.mds-heading-3 {
				--mds-typography-font-size: var(--mds-typography-scale-size-l);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-xl
				);
			}

			h4 {
				--mds-typography-font-size: var(--mds-typography-scale-size-m);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-s
				);
			}

			h5 {
				--mds-typography-font-size: var(--mds-typography-scale-size-s);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-m
				);
			}

			h6 {
				--mds-typography-font-size: var(--mds-typography-scale-size-s);
				--mds-typography-font-height: var(
					--mds-typography-scale-height-m
				);
			}
		}

		button,
		[type="button"],
		[type="reset"],
		[type="submit"] {
			-webkit-appearance: unset;
		}

		a:link,
		a:active,
		a:visited,
		a:hover {
			text-decoration: none;
			border-bottom: var(--mds-line-border-base-weight)
				var(--mds-line-border-base-style)
				var(--mds-color-border-hyperlink);
			color: var(--mds-color-text-link);
		}

		a:hover {
			color: var(--mds-color-text-link-hover);
		}

		[ondark] a:link,
		[ondark] a:active,
		[ondark] a:visited,
		[ondark] a:focus-visible,
		[ondark] a:hover,
		a[ondark]:link,
		a[ondark]:active,
		a[ondark]:visited,
		a[ondark]:focus-visible,
		a[ondark]:hover {
			text-decoration: none;
			border-bottom: var(--mds-line-border-base-weight)
				var(--mds-line-border-base-style)
				var(--mds-color-border-hyperlink-inverse);
			color: var(--mds-color-text-link-inverse);
		}

		[ondark] a:hover,
		a[ondark]:hover {
			color: var(--mds-color-text-link-inverse-hover);
		}

		:host :focus-visible {
			outline-color: var(--mds-color-border-focus);
			outline-style: var(--mds-line-border-base-style);
			outline-offset: var(--mds-line-border-base-offset);
			outline-width: var(--mds-line-border-base-outline);
		}

		:host([ondark]) :focus-visible {
			outline-color: var(--mds-color-border-focus-inverse);
		}
	}
`;
